import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Chip,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import CurrencyFormat from "../../../../../services/CurrencyFormat";
import AgapeIcon from "../../../../common/icons/AgapeIcon";

const useStyles = makeStyles({
  root: {
    maxWidth: 350,
    position: "relative",
    overflow: "visible",
    borderRadius: "2rem",
    boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
  },
  root2: {
    maxWidth: 350,
    position: "relative",
    overflow: "visible",
    borderRadius: "2rem",
    boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
    padding: "1.3rem",
    marginTop: ".1rem",
    borderTop: "1px #aaa dashed",
  },
  done: {
    position: "absolute",
    backgroundColor: "#2e4cff",
    color: "#fff",
    fontSize: "1rem",
    padding: ".3rem 1.4rem",
    fontFamily: "Vazir",
    borderRadius: "2rem",
    top: "5%",
    left: "5%",
  },
  imageBox: {
    width: "150px",
    position: "absolute",
    top: "-35px",
    left: "27%",
  },
  title: {
    fontFamily: "Vazir-Bold",
  },
  image: {
    width: "100%",
  },
  content: {
    paddingTop: "100px",
    textAlign: "center",
  },
  textBox2: {
    backgroundColor: "#ededed",
    height: "193.5px",
    overflow: "hidden",
    margin: "0 3rem",
    padding: "1rem 1rem 1rem 1rem",
    borderRadius: "2rem",
  },
  actions: {
    margin: "1rem auto",
    textAlign: "center",
  },
  off: {
    color: "#2e4cff",
    fontFamily: "Vazir-Bold",
    fontSize: "1rem",
    marginRight: ".5rem",
  },
  btn: {
    borderRadius: "2rem",
    fontFamily: "Vazir-Bold",
    border: "3px #009693 solid",
    fontSize: "1.4rem",
    color: "#009693",
    padding: "20px 30px !important",
  },
  orge: {
    width: "40px",
  },
});

export default function ImgMediaCard({
  id,
  image,
  province,
  city,
  title,
  status,
  description,
  priceId,
  price,
  orgName,
  orgLogo,
}) {
  const classes = useStyles();

  return (
    <Box>
      <Link href={`/agape-digikala/${id}`}>
        <a style={{ color: "#009693", width: "100%" }}>
          <Card className={classes.root}>
            <CardActionArea>
              {status === "done" && (
                <div className={classes.done}>تامین شده</div>
              )}
              <Container className={classes.imageBox}>
                {image && (
                  <Image
                    src={image}
                    alt="cardImage"
                    className={classes.image}
                    blurDataURL={image}
                    placeholder="blur"
                    width={150}
                    height={150}
                  />
                )}
              </Container>
              <CardContent className={classes.content}>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  className={classes.title}
                >
                  {title}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="h3"
                >
                  <AgapeIcon icon="place" size="1rem" />
                  {`${city}${province}`}
                </Typography>
              </CardContent>
              <CardContent className={classes.textBox2}>
                <Typography component="h4">{description}</Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                className={classes.actions}
              >
                <Typography
                  component="h1"
                  variant="h5"
                  style={{ fontFamily: "Vazir", marginBottom: "1rem" }}
                >
                  {/* <span className={classes.off}>{`(${10}%)`}</span> */}
                  {priceId !== 0 ? CurrencyFormat(price / 10) : `عدم موجودی`}
                  {priceId !== 0 && <Chip label="تومان" />}
                </Typography>
                <Button
                  endIcon={<ArrowBackIosIcon style={{ fontSize: "1.5rem" }} />}
                  className={classes.btn}
                >
                  میخواهم حمایت کنم
                </Button>
              </Box>
            </CardActions>
          </Card>
          <Box
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            className={classes.root2}
          >
            <Grid container>
              <Grid item style={{ width: "40px" }}>
                <Image
                  src={orgLogo}
                  alt="orga"
                  style={{ width: "100%" }}
                  blurDataURL={orgLogo}
                  placeholder="blur"
                  width={40}
                  height={40}
                />
              </Grid>
              <Grid item md={9}>
                <Typography style={{ padding: "10px 10px 0 0" }}>
                  {orgName}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </a>
      </Link>
    </Box>
  );
}
